import React, { useEffect, useState } from "react";
import { ApiURL } from "../../../../../services/apiConstants";
import { post } from "../../../../../services/services";
import SisLoader from "../../../../../widgets/loader";
import CargoCraneDetailsTable from "../../components/CargoCraneCom/CargoCraneRow";

function StaffCargoCrane({ id }) {
  const [loader, setLoader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  const fetchCargoCraneList = async () => {
    setLoader(true);
    const formData = new FormData();
    formData.append("ship_id", id);

    try {
      const res = await post(ApiURL.list_ship_cargo_crane_details_st, formData);
      if (res?.status === true) {
        setFilteredData(res?.crane_parameters_data || []);
      }
    } catch (error) {
      console.error("Error fetching Cargo Crane list:", error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchCargoCraneList();
  }, []);

  return (
    <>
      <h3 style={{ margin: "15px 0", fontWeight: "600" }}>Cargo Crane Information</h3>
      {loader ? (
        <SisLoader />
      ) : filteredData.length > 0 ? (
        <CargoCraneDetailsTable data={filteredData} />
      ) : (
        <p>No data available</p>
      )}
    </>
  );
}

export default StaffCargoCrane;
